import React from "react";
import { useDispatch } from "react-redux";
import { handleCommonModal, handleProductModal } from "../../../action/quote_order/leadcustomer.action";
import { CheckCaptureModalImage } from "../../../action/extra_options/orderExtras.action";
import { handleSaveLatter, handleSavePublicQuote } from "../../../action/quote_order/quote.action";
import { const_var } from "../../../redux/reducers/reducer";
import { downloadOnClick, prepareTwoDMapData } from "../../../action/2d_mapping/twoDMap.action";
import { ShowMeasure } from "../../../action";


const SaveButtonFunction = ({class_name, headerShow = false}) =>{

    const dispatch = useDispatch()
    const onSaveClick = async () => {
        await dispatch(downloadOnClick(false));
        await dispatch(prepareTwoDMapData());
        //autoGeneratedPDF();
        if (const_var.callMesure) {
            dispatch(ShowMeasure("save"))
          }
    };
    
    
     const onQuoteClick = async () => {
        await dispatch(downloadOnClick(false));
        await dispatch(prepareTwoDMapData());
        dispatch(handleSaveLatter('open'));
        if (const_var.callMesure) {
          dispatch(ShowMeasure("save"))
        }
      };
    return(
        <div data-tut="leftpanelfooter">
            {  //for save button without login case
                const_var.loginSession == false
                ?
                <>
                    {(const_var.crmSetting.is_module_name == "inventory") ?

                            <a className={const_var.crmSetting.order_now == true && const_var.checkmoreCustomizeFlag == false ? class_name : class_name }
                                id="save_update_inventory_automation"
                                onClick={(e) => dispatch(handleProductModal())}
                            >
                                {!headerShow && <span className="icon icon-save"></span>}
                                <span className="text sales-login-text">
                                {(const_var.crmSetting.form_action == "edit") ? "Update" : (const_var.crmSetting.main_domain_url == "prometalbuildings.com" || const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}
                                </span>
                            </a>

                        :
                        <>
                        {(const_var.isPublicEdit != true)
                            ?
                                <a className={const_var.crmSetting.order_now == true && const_var.checkmoreCustomizeFlag == false ? class_name : class_name }
                                
                                id="save_update_orderquote_automation"
                                onClick={(const_var.crmSetting.form_action == "edit" &&
                                    const_var.i_g_A_y.length > 0)
                                    ?
                                    (e) => {
                                        dispatch(CheckCaptureModalImage('open'));
                                        onSaveClick();
                                    }
                                    :
                                    (const_var.loginSession == false)
                                    ?
                                    (e) => {
                                        dispatch(handleSaveLatter('open'));
                                        onSaveClick();
                                    }
                                    :
                                    (e) => {
                                        dispatch(handleCommonModal('lead_customer', 'save'));
                                        onSaveClick();
                                    }
                                }
                                >
                                    <span className="text">
                                        {
                                        const_var.crmSetting.form_action == "edit"
                                            ?
                                            (const_var.crmSetting.is_module_name == "quote")
                                            ?
                                            headerShow ? "Update" : "Update Quote"
                                            :
                                            headerShow ? "Update" : "Update Order"
                                            :
                                            (const_var.crmSetting.is_module_name == "quote")
                                        ?
                                            (!headerShow && const_var.crmSetting.main_domain_url == "solidrockstructuresllc.com") ? "Click Here For Current Specials" : const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!" : (headerShow ? (const_var.crmSetting.main_domain_url == "prometalbuildings.com" || const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save") : "Save & Share "))
                                        :
                                            (!headerShow && const_var.crmSetting.main_domain_url == "solidrockstructuresllc.com") ? "Click Here For Current Specials" : const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!" : (headerShow ? (const_var.crmSetting.main_domain_url == "prometalbuildings.com" || const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save") : "Save & Share "))
                                        }
                                    </span>
                                    {!headerShow && <span className='icon'><i className='icon-double-arrow-ico'></i></span>}
                                </a>
                            :
                                <a className={(const_var.crmSetting.order_now == true && const_var.checkmoreCustomizeFlag == false ? class_name : class_name) + (const_var.isPublicUrlNonEditable == true ? ' d-none' : '') }
                                    id="save_update_orderquote_automation"
                                    onClick={(e) => { dispatch(handleSavePublicQuote('open'));   onSaveClick(); }}
                                >
                                    <span className='text'>{headerShow ? "Update" : "Update & Share"}</span>
                                    {!headerShow && <span className='icon'><i className='icon-double-arrow-ico'></i></span>}
                                </a>
                        }
                        </>
                    }
                </>
                :
                <>
                    {(const_var.crmSetting.is_module_name == "inventory") ?
  
                        <a className={const_var.crmSetting.order_now == true && const_var.checkmoreCustomizeFlag == false ? class_name : class_name }
                                id="save_update_inventory_automation"
                                onClick={(e) => dispatch(handleProductModal())}
                        >
                                <span className='text'>{(const_var.crmSetting.form_action == "edit") ? "Update" : const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!" : (headerShow ? (const_var.crmSetting.main_domain_url == "prometalbuildings.com" || const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save") : "Save & Share "))}</span>
                                {!headerShow && <span className='icon'><i className='icon-double-arrow-ico'></i></span>}
                        </a>

                        :
                        <>
                        {(const_var.isPublicEdit != true)
                            ?
                                <a className={const_var.crmSetting.order_now == true && const_var.checkmoreCustomizeFlag == false ? class_name : class_name }
                                    id="save_update_orderquote_automation"
                                    onClick={(const_var.crmSetting.form_action == "edit" &&
                                        const_var.i_g_A_y.length > 0)
                                        ?
                                        (e) => {
                                            dispatch(CheckCaptureModalImage('open'));
                                            onSaveClick();
                                        }
                                        :
                                        (const_var.loginSession == false)
                                        ?
                                        (e) => {
                                            onQuoteClick();
                                            onSaveClick();
                                        }
                                        :
                                        (e) => {
                                            dispatch(handleCommonModal('lead_customer', 'save'));
                                            onSaveClick();
                                        }
                                    }
                                >
                                    <span className="text">
                                        {
                                        const_var.crmSetting.form_action == "edit"
                                            ?
                                            (const_var.crmSetting.is_module_name == "quote")
                                            ?
                                            headerShow ? "Update" : "Update Quote"
                                            :
                                            headerShow ? "Update" : "Update Order"
                                            :
                                            (const_var.crmSetting.is_module_name == "quote")
                                        ?
                                            const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!" : (headerShow ? (const_var.crmSetting.main_domain_url == "prometalbuildings.com" || const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save") : "Save & Share "))
                                        :
                                            const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!" : (headerShow ? (const_var.crmSetting.main_domain_url == "prometalbuildings.com" || const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save") : "Save & Share "))
                                        }
                                    </span>
                                    {!headerShow && <span className='icon'><i className='icon-double-arrow-ico'></i></span>}
                                </a>

                            :
                                <a className={const_var.crmSetting.order_now == true && const_var.checkmoreCustomizeFlag == false ? class_name : class_name }
        
                                    id="save_update_orderquote_automation"
                                        onClick={(e) => { dispatch(handleSavePublicQuote('open'));   onSaveClick(); }}
                                >
                                    <span className='text'>{headerShow ? "Update" : "Update & Share"}</span>
                                    {!headerShow && <span className='icon'><i className='icon-double-arrow-ico'></i></span>}
                                </a>

                        }
                        </>
                    }
                </>
            }
        </div>
    )
}
export default SaveButtonFunction;